import React, { useEffect, useState } from 'react';
import useDebounce from '../../../core/common/hooks/useDebounce';
import FilterPopup from './FilterPopup';
import { useDispatch } from 'react-redux';
import { setCommonData } from '../../../core/Features/commonSlice';
interface BannerProps {
    setSearchAkash: React.Dispatch<React.SetStateAction<any>>;
    setAkash2: React.Dispatch<React.SetStateAction<any>>;
    setAkash3: React.Dispatch<React.SetStateAction<any>>;
    apiValues: any
}

interface StudyItem {
    emoji: string;
    label: string;
}
const SearchFilterSort: React.FC<BannerProps> = ({ setSearchAkash, setAkash2, setAkash3, apiValues }) => {

    const [selectedAll, setSelectedAll] = useState<Record<string, string[]>>({});
    const [selectedCard, setSelectedCard] = useState<StudyItem | null>(null);
    const dispatch = useDispatch()

    const [searchText, setSearchText] = useState<string>('');
    const debouncedSearchText = useDebounce(searchText, 500); // 500ms delay
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value.toLowerCase());
    };
    const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAkash2(e.target.value);
    };
    const closeModal = () => setSelectedCard(null);
    useEffect(() => {
        dispatch(setCommonData({ filterDestination: selectedAll }));

    }, [selectedAll])

    // Optional: useEffect to handle escape key
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') closeModal();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);
    useEffect(() => {
        if (selectedCard) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [selectedCard]);


    useEffect(() => {

        setSearchAkash(debouncedSearchText)
    }, [debouncedSearchText])
    return (
        <div className="w-full px-4 py-6">
            <div className="flex flex-col md:flex-row items-center gap-4 justify-between flex-wrap">

                {/* Filter Button */}
                <button
                    onClick={() => setSelectedCard({ label: 'University Filters', emoji: '🎓' })}

                    className="cursor-pointer flex items-center bg-[#1D1753] text-white px-4 py-2 rounded-lg shadow-sm w-full md:w-auto justify-center gap-4">
                    <span onClick={() => setSelectedCard({ label: 'University Filters', emoji: '🎓' })}
                        className="text-xl">🔽</span>
                    <div onClick={() => setSelectedCard({ label: 'University Filters', emoji: '🎓' })}
                        className="w-px h-5 bg-white/30"></div>
                    <span onClick={() => setSelectedCard({ label: 'University Filters', emoji: '🎓' })}
                        className="text-sm" >Filter university</span>
                </button>

                {/* Sort Button */}
                <div className="flex items-center border border-gray-300 bg-white px-4 py-2 rounded-lg shadow-sm w-full md:w-auto gap-2">
                    <span className="text-xl">↕️</span>
                    <div className="w-px h-5 bg-gray-300"></div>
                    <select
                        className="text-sm text-gray-700 bg-white focus:outline-none"
                        defaultValue="popularity"
                        onChange={handleSortChange}

                    >
                        <option value="rankingNumber">Sort By:Popularity</option>
                        <option value="asc">University Name(A-Z)</option>
                        <option value="desc">University Name(Z-A)</option>
                    </select>
                </div>


                {/* Search Input */}
                <div className="flex w-full md:flex-1 max-w-xl rounded-md border border-gray-300 overflow-hidden shadow-sm">
                    <input
                        value={searchText}
                        onChange={handleSearch}

                        type="text"
                        placeholder="Search for University"
                        className="flex-grow px-4 py-3 text-sm focus:outline-none"
                    />
                    {/* <button className="bg-[#EA1D2A] text-white w-10 h-10 rounded-md flex items-center justify-center m-2">
                        <span className="text-xl font-bold">→</span>
                    </button> */}
                </div>
            </div>

            <FilterPopup
                apiValues={apiValues}
                selectedCard={selectedCard}
                closeModal={() => setSelectedCard(null)}
                onApplyFilters={(filters) => {
                    const safeFilters = {
                        countries: filters?.destinations ?? [],
                        // levels: filters?.levels ?? [],
                    };
                    setSelectedAll(safeFilters);
                }}

            />

        </div >
    );
};

export default SearchFilterSort;
